module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_7016.172f9892.png";